export const TARIFFS_GO = [
    {
        'title': 'не страховать',
        'isum': 0,
        'psum': 0,
    },
    {
        'title': 'на 300 000 рублей за 1200 р.',
        'isum': 300000,
        'psum': 1200,
    },
    {
        'title': 'на 400 000 рублей за 1600 р.',
        'isum': 400000,
        'psum': 1600,
    },
    {
        'title': 'на 500 000 рублей за 2000 р.',
        'isum': 500000,
        'psum': 2000,
    },
    {
        'title': 'на 600 000 рублей за 2400 р.',
        'isum': 600000,
        'psum': 2400,
    },
    {
        'title': 'на 750 000 рублей за 3000 р.',
        'isum': 750000,
        'psum': 3000,
    },
    {
        'title': 'на 1 000 000 рублей за 4000 р.',
        'isum': 1000000,
        'psum': 4000,
    },
];

export const TARIFFS_TRANSLATIONS_MAP = {
    realEstate: 'Страхование недвижимости',
    life: 'Страхование жизни',
}

export const GLOBAL_MODAL_KEYS_MAP = {
    successPolicyIssuance: 'payment_success',
}

export const INSURANCE_CARDS = [
    {
        tariff: 'property',
        title: TARIFFS_TRANSLATIONS_MAP.realEstate,
        subtitle: 'При повреждении объекта залога (только конструктивные элементы) страховая компания выплатит остаток задолженности по ипотеке перед банком за Вас',
        price: '100 000',
        cardPrice: '0',
        cardTooltip: 'Страхование имущества для ипотечного кредита позволяет компенсировать расходы перед банком при пожаре, взрыве бытового газа и других авариях инженерных систем. Страхование распространяется на несущие и не несущие стены, перекрытия, перегородки, окна, входные двери. На внутреннюю отделку покрытие не распространяется.',
        isSelected: true,
    },
    {
        tariff: 'life',
        title: TARIFFS_TRANSLATIONS_MAP.life,
        subtitle: 'Оформляя страховку жизни и здоровья вы сохраняете процентную ставку по договору на прежнем уровне и получаете возможность компенсации расходов по кредиту в случае непредвиденных обстоятельств',
        tooltipText: 'Какая-то подсказка для большего понимания написанного в карточке',
        price: '100 000',
        cardPrice: '0',
        cardTooltip: 'При заболевании, инвалидности или смерти выплата остатка долга по кредиту будет выполнена страховой компанией.',
        isSelected: false,
    },
];

export const PHONE_LENGTH = 11;

export const PERSON_PASSPORT_LENGTH = 10;

export const DEPARTMENT_CODE_LENGTH = 6;

export const MAX_QUERY_LENGTH = 255;